import type { User } from '@/types/user'

export enum Role {
	Admin = 'admin',
	Restocker = 'restocker',
}

export function mapBackendUserToPlatformRole(user: User): Role {
	if (user.is_admin) return Role.Admin
	return Role.Restocker // default role since no other
}
